import React, { FC } from 'react'
import styles from 'styles/components/footer.module.scss'
import { FooterSitemap } from './index'

const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <FooterSitemap />
    </footer>
  )
}

export default Footer
